<script setup>
import Home from '@/views/Home.vue'
</script>

<template>  
  <Home/>
</template>
<style scoped>
</style>
